import QRCode from "qrcode.react";
import React, {useEffect, useState} from "react";
import {DEFAULT_LANGUAGE, getI18nTextWithContext} from "wipi-common/src/lib/i18n";
import {useI18nContext} from "../i18n/I18nContext";
import PropTypes from "prop-types";

const APP_DEEPLINK_BASE = process.env.REACT_APP_APP_DEEPLINK_BASE

export default function QRLayout({caseId, illustrationDark, illustrationLight}) {
    const context = useI18nContext()
    const [language, setLanguage] = useState(DEFAULT_LANGUAGE)
    const qrCode = getI18nTextWithContext(context, 'eIDstart.qrCode');
    const qrDescription = getI18nTextWithContext(context, 'eIdStart.qrCode.description');
    const lineBreak = ":";

    useEffect(() => {
        setLanguage(context.lang)
    }, [context])

    return <div className="row">
        {/* QR Code description */}
        {(illustrationLight && illustrationDark) &&
            <div className="col-xxl-4 offset-xxl-0 col-xl-4 offset-xl-0 col-lg-5 offset-lg-0 col-md-6 offset-md-3
            col-sm-6 offset-sm-3 mb-sm-3 col-6 offset-3 mb-3">
                <img id="illustration-light" className="description-illu" src={illustrationLight}
                     alt="" data-test-id="09ea9966-711b"/>
                <img id="illustration-dark" className="description-illu" src={illustrationDark}
                     alt="" data-test-id="09ea9966-711b"/>
            </div>
        }
        <div className="col-xxl-3 offset-xxl-0 col-xl-4 offset-xl-0 col-lg-3 offset-lg-0 col-md-8 offset-md-0
        col-sm-8 col-12 d-flex flex-column justify-content-center">
            <div className="qr-description-title">
                {qrCode + lineBreak}
            </div>
            <p className="qr-description" data-test-id="aavnayhje4tk">
                {qrDescription}
            </p>
        </div>
        {/* QR Code */}
        <div className="col-xxl-3 offset-xxl-0 col-xl-4 offset-xl-0 col-lg-4 offset-lg-0 col-md-4 offset-md-0
        col-sm-4 col-5 d-flex align-items-center d-flex centeredQR">
            <div className="cornered-border">
                <div className="container-color">
                    <div className="qrcode-light">
                        <QRCode value={APP_DEEPLINK_BASE + caseId + '&lang=' + language} size={100}/>
                    </div>
                    <div className="qrcode-dark">
                        <QRCode value={APP_DEEPLINK_BASE + caseId + '&lang=' + language} size={100} bgColor="#171920" fgColor="#8292AA"/>
                    </div>
                </div>
                <div className="corner top-left mr-2 ml-2"></div>
                <div className="corner top-right ml-2"></div>
                <div className="corner bottom-left"></div>
                <div className="corner bottom-right"></div>
            </div>
        </div>
    </div>
}

QRLayout.propTypes = {
    illustrationLight: PropTypes.string,
    illustrationDark: PropTypes.string,
    caseId: PropTypes.string.isRequired
};